/**
 * UMBRAL — Sistema global de preferencias de lectura para Albino.
 * 
 * Detecta preferencias del sistema y permite al usuario elegir
 * "otra forma" de leer con más contraste, espacio y sin animaciones.
 * 
 * El estado persiste en sessionStorage durante la visita.
 */
(function () {
  'use strict';

  function detectSystemPreferences() {
    var p = window.matchMedia;
    return (p && p('(prefers-reduced-motion: reduce)').matches) ||
           (p && p('(prefers-contrast: more)').matches) ||
           (parseFloat(getComputedStyle(document.documentElement).fontSize) >= 18);
  }

  function setOtraForma(on, fromSystem) {
    if (fromSystem) {
      document.documentElement.classList.add('forma-adaptada', 'forma-otra');
      document.body.classList.add('forma-adaptada', 'forma-otra');
    } else {
      document.documentElement.classList.toggle('forma-otra', on);
      document.body.classList.toggle('forma-otra', on);
      if (on) {
        try {
          sessionStorage.setItem('albino-forma', 'otra');
        } catch (e) {}
      }
    }

    // Actualizar textos de los umbrales
    document.querySelectorAll('.umbral-base').forEach(function (el) {
      el.style.display = on ? 'none' : '';
    });
    document.querySelectorAll('.umbral-activo').forEach(function (el) {
      el.style.display = on ? '' : 'none';
    });
  }

  function initUmbral() {
    // Detectar preferencias del sistema
    if (detectSystemPreferences()) {
      setOtraForma(true, true);
      return;
    }

    // Verificar sessionStorage
    try {
      if (sessionStorage.getItem('albino-forma') === 'otra') {
        setOtraForma(true, false);
        return;
      }
    } catch (e) {}

    // Vincular botones de umbral
    var umbralButtons = document.querySelectorAll('#btn-umbral, #mobile-umbral-btn');
    umbralButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOtraForma(true, false);
        if (navigator.vibrate) navigator.vibrate(30);
        
        // Cerrar menú móvil si está abierto
        var mobileMenu = document.getElementById('mobile-menu');
        if (mobileMenu && mobileMenu.classList.contains('opacity-100')) {
          var closeBtn = document.getElementById('mobile-close-btn');
          if (closeBtn) closeBtn.click();
        }
      });
    });
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUmbral);
  } else {
    initUmbral();
  }
})();
